import { FC } from 'react'
import { MaterialRequirementsConfiguration } from '../../../../../../types/api/components/material/material-requirements-configuration'
import { useGetStocksQuery } from '../../../../../../store/api/stocks-api'
import Text from 'antd/es/typography/Text'
import MaterialType from '../../../../../../types/api/material-type'

interface ReserveProps {
    config: MaterialRequirementsConfiguration
    shipmentDocId: string
    materialType: MaterialType
}

const Reserve: FC<ReserveProps> = ({ config, shipmentDocId, materialType }) => {
    const unitShortName = materialType?.unit?.shortName
    // Зарезервировать - искать сток по материалу и смотреть там наличиее резервации для данной отгрузки
    const { data } = useGetStocksQuery(
        {
            filters: {
                material: { documentId: { $eq: config.material?.documentId } },
            },
            populate: {
                stock_reserves: { populate: '*' },
            },
        },
        { refetchOnMountOrArgChange: true }
    )
    const stocks = data?.data || []

    if (stocks.length === 0) {
        return (
            <Text type={'danger'}>
                {config.material?.width} {config.amount} {unitShortName} - Ошибка, нет остатков
            </Text>
        )
    }
    if (stocks.length > 1) {
        return (
            <Text type={'danger'}>
                {config.material?.width} {config.amount} {unitShortName} - Ошибка, несколько остатков
            </Text>
        )
    }
    const stock = stocks[0]

    const reservedStock = stock.stock_reserves?.find(
        x => x.shipment?.documentId === shipmentDocId && x.amount === config.amount
    )

    if (!reservedStock) {
        return (
            <Text type={'warning'}>
                {config.material?.width} {config.amount} {unitShortName} - Будет зарезервировано
            </Text>
        )
    }

    return (
        <div>
            <Text strong>{config.material?.width}</Text> зарезервировано {reservedStock.amount}{' '}
            {unitShortName}
        </div>
    )
}

export default Reserve
